const HelpText = () => {
  return (
    <div className='flex flex-col gap-4'>
      <p>These charts use live pass data for the currently selected client.</p>
      <p>Use the period selector to switch between short-term and long-term views. Chart buckets change automatically to fit the selected period.</p>
      <p>You can also switch between all templates and a single template to focus on one campaign or pass type.</p>
    </div>
  )
}

export default HelpText
